export const parseBreakpointString = (breakpointString: string | undefined | null, trimValues?: boolean) => {
    if (!breakpointString) {
        return undefined;
    }

    return breakpointString
        .replace(/^.*\[|\].*$/g, "")
        .split(",")
        .map(value => {
            const _value = trimValues ? value.trim() : value;
            return _value === "null" ? null : _value;
        });
};

export const isValidBreakpointString = (value: string | undefined | null) => {
    return value && /^\s*\[(?!,)(?!.*(,,|,\]))[^\[\]]+\]\s*$/.test(value);
};

export const validateBreakpointTextField = (
    value: string | number,
    validate?: (value: string | undefined | null) => string,
    trimValues?: boolean,
) => {
    const _value = typeof value === "number" ? `${value}` : value;

    if (_value && ["[", "]"].some(x => _value.includes(x))) {
        if (!isValidBreakpointString(_value)) {
            return "The breakpoint array is invalid";
        }

        if (validate) {
            for (const breakpointValue of parseBreakpointString(_value, trimValues) || []) {
                const errorMessage = validate(breakpointValue);

                if (errorMessage) {
                    return errorMessage;
                }
            }

            return "";
        }
    }

    return validate?.(_value) || "";
};
